// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// Components Imports
import SelectedSheetComponent from "./SelectedSheetComponent";
import GoogleCatalogList from "./GoogleCatalogList";

class GoogleCatalog extends Component {
  state = {
    sheetEditMode: false,
    selectedSheet: {},
    selectedWorkSheet: "",
    selectedRangeValue: "",
    selectedRangeValueStartedChanging: false,
  };

  componentDidMount() {
    if (
      this.props.currentGSheet &&
      this.props.currentGSheet.sheet &&
      this.props.currentGSheet.workSheet
    ) {
      this.setState({
        selectedSheet: this.props.currentGSheet.sheet,
        sheetEditMode: true,
        selectedWorkSheet: this.props.currentGSheet.workSheet,
        selectedRangeValue: this.props.currentGSheet.rangeValue,
      });
    }
  }

  componentDidUpdate(prevProps) {
    this._stateUpdateHandling(prevProps);
  }

  _stateUpdateHandling = prevProps => {
    if (
      this.props.googleSheetSectionId !== prevProps.googleSheetSectionId &&
      this.props.currentGSheet &&
      this.props.currentGSheet.connected
    ) {
      this.setState({
        selectedSheet: this.props.currentGSheet.sheet,
        sheetEditMode: true,
        selectedWorkSheet: this.props.currentGSheet.workSheet,
        selectedRangeValue: this.props.currentGSheet.rangeValue,
      });
    } else if (
      this.props.googleSheetSectionId === prevProps.googleSheetSectionId &&
      this.props.currentGSheet &&
      this.props.currentGSheet.sheet.id === this.state.selectedSheet.id &&
      this.props.currentGSheet.workSheet === this.state.selectedWorkSheet &&
      this.state.selectedRangeValue === "" &&
      this.props.currentGSheet.rangeValue !== "" &&
      this.state.selectedRangeValueStartedChanging === false
    ) {
      this.setState({
        selectedRangeValue: this.props.currentGSheet.rangeValue,
      });
    } else if (
      this.props.googleSheetSectionId !== prevProps.googleSheetSectionId &&
      !this.props.currentGSheet.connected
    ) {
      this.setState({
        selectedSheet: {},
        selectedWorkSheet: "",
        sheetEditMode: false,
        selectedRangeValue: "",
      });
    }
  };

  _changeSheetData = () => {
    this.setState({
      selectedSheet: {},
      selectedWorkSheet: "",
      sheetEditMode: false,
      selectedRangeValue: "",
      selectedRangeValueStartedChanging: false,
    });
  };

  _sheetSelection = data => {
    this.setState({
      selectedSheet: data,
      sheetEditMode: true,
    });
  };

  _upatedGoogleSheetTable = data => {
    this.setState({
      selectedWorkSheet: data,
      selectedRangeValue: "",
      selectedRangeValueStartedChanging: false,
    });
  };

  _setRangeValue = e => {
    console.debug("_setRangeValue", e.target.value);
    this.setState({
      selectedRangeValueStartedChanging: true,
      selectedRangeValue: e.target.value.trim().toUpperCase(),
    });
  };

  _upatedSelectedRangeValueStatus = () => {
    this.setState({
      selectedRangeValueStartedChanging: false,
    });
  };

  render() {
    const {
      selectedSheet,
      sheetEditMode,
      selectedWorkSheet,
      selectedRangeValue,
    } = this.state;
    return (
      <Fragment>
        <div className="googlesheet-cataglog-container animated fadeinright">
          {sheetEditMode ? (
            <div className="googlesheet-cataglog-sheet-container">
              <SelectedSheetComponent
                sheetData={selectedSheet}
                selectedWorkSheet={selectedWorkSheet}
                selectedRangeValue={selectedRangeValue}
                changeSheetData={this._changeSheetData}
                upatedGoogleSheetTable={this._upatedGoogleSheetTable}
                setRangeValue={this._setRangeValue}
                upatedSelectedRangeValueStatus={
                  this._upatedSelectedRangeValueStatus
                }
              />
            </div>
          ) : (
            <GoogleCatalogList sheetSelection={this._sheetSelection} />
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { googleSheetId } = state.QuotationStore;
  const { currentGSheetTab } = state.GoogleSheetStore;
  const currentGSheet = currentGSheetTab;
  // const currentGSheet = gSheetRevvTables[googleSheetId];
  const { sheet, workSheet, rangeValue } = currentGSheet || {};
  return {
    googleSheetSectionId: googleSheetId,
    currentGSheet,
    sheet,
    workSheet,
    rangeValue,
  };
};

export default connect(
  mapStateToProps,
  null,
)(GoogleCatalog);



// WEBPACK FOOTER //
// ./src/components/GoogleCatalog/index.js